import type { DueBadge as DueBadgeData } from "@icraftx/shared/v1";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

/** Compact due urgency label — plan/30 */
export function DueBadge({
  badge,
  onFilterClick,
}: {
  badge: DueBadgeData;
  /** Click filters the list by this due urgency (toggle). */
  onFilterClick?: () => void;
}) {
  if (badge.kind === "none" || !badge.label) return null;
  const variant =
    badge.kind === "overdue"
      ? "destructive"
      : badge.kind === "today"
        ? "default"
        : "outline";
  if (onFilterClick) {
    return (
      <button
        type="button"
        className="cursor-pointer rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ring)]"
        title={`Filter: ${badge.label}`}
        onClick={onFilterClick}
      >
        <Badge variant={variant} className="pointer-events-none">
          {badge.label}
        </Badge>
      </button>
    );
  }
  return <Badge variant={variant}>{badge.label}</Badge>;
}

/** @deprecated Prefer FilterTagPill / ListTagPills — plan/35. */
export { FilterTagPill as FilterTagChip } from "@/modules/tags/components/TagPill";

/** Customer / supplier name — click filters the list to that party. */
export function FilterPartyName(props: {
  name: string;
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      title={`Filter: ${props.name}`}
      onClick={props.onClick}
      className={cn(
        "cursor-pointer text-left hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ring)]",
        props.className,
      )}
    >
      {props.name}
    </button>
  );
}
